<template>
  <!-- <div class="calendar_Wrapper">
        <div id="calendar">
        
        <h2>{{ monthYear }}</h2>
        <table>
            <thead>
                <tr>
                    <th v-for="day in days" :key="day">{{ day }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="week in calendar" :key="week">
                    <td v-for="date in week" :key="date">{{ date }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    </div> -->
  <div v-if="cType === 'half'" class="Date-wrapper d-flex align-items-center justify-content-center"
    :style="{ color: color }">

    <div class="showDate" :style="{ color: color, fontSize: `${fs}px` }">
      {{ this.dateClock }}
    </div>

  </div>
  <div v-else class="cwrapper" :style="{ width: width, height: height }">
    <div id="full-clndr">
      <div class="clndr">
        <div class="clndr-controls">
          <div class="current-month">October 2023</div>
        </div>
        <div class="clndr-wrapper">
          <div class="clndr-grid">
            <div class="days-of-the-week d-flex clearfix" :style="{ backgroundColor: bgColorL }">
              <div v-for="day in days" :key="day + ' ' + Math.random()" class="header-day" :style="{ color: Hcolor , fontSize: adjustFontSizeOfDates + 'px' }"> {{ day }}</div>
            </div>
            <div class="days">

              <div v-for="date in calendar" :style="{ backgroundColor: bgColorL, color: Dcolor }"
                :key="date + ' ' + Math.random()" class="day past calendar-day-2023-10-01 calendar-dow-0" id=""><span
                  class="day-number" :style="{fontSize: adjustFontSizeOfDates + 'px' , color: new Date().getDate() == date && Tcolor , fontWeight: new Date().getDate() == date && 900 }">{{ date }}</span></div>



            </div>
          </div>
          <div class="today-block-v1">
            <div class="today-block-title">Wednesday</div>
            <div class="today-block-day">
              <span>11</span>
            </div>
          </div>
          <div class="today-block-v2" :style="{ backgroundColor: bgColorR }">
            <div class="today-block-wrapper">
              <div class="today-block-day text-right" :style="{ color: Dcolor ,fontSize: adjustFontSizeTodayDate + 'px' }">{{ todayDate }}</div>
              <div class="dow text-right" :style="{ color: Tcolor , fontSize: adjustFontSizeTExtTodayDate + 'px' }">{{ today }}</div>
              <div class="ym text-right" :style="{ color: Tcolor , fontSize: (adjustFontSizeTExtTodayDate) + 'px' }">{{ currentMonthInText }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: "calendarApp",
  data() {
    return {
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],
      days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      today: new Date(),
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      selectedDate: null,
      currentMonthInText: moment().locale(this.lang).format("MMMM YYYY"),
      todayDate:moment().locale(this.lang).format("D"),
      dateClock: "",
      componentKey: 0,
      defaultWidth:0,
      todayDateFS:0,
      todayDateTextFS:0,
      DATESFS:0,

    }
  },
  props: {
    width: String,
    height: String,
    fs: Number,
    format: String,
    color: String,
    cType: String,
    bgColorL: String,
    bgColorR: String,
    Hcolor: String,
    Dcolor: String,
    Tcolor: String,
    beginweek:String,
    lang:String,
    calcWidth:Number,
    zoomRatio:Number
  },
  mounted() {
    this.today = moment().locale(this.lang).format("dddd");
    this.dateClock = moment().format(this.format);
    this.defaultWidth = this.calcWidth;
    // this.adjustFontSizeTodayDate();
    // this.adjustFontSizeTExtTodayDate();
    // this.adjustFontSizeOfDates();
  },
  watch: {
    format(handlevalues) {
      this.dateClock = moment().format(handlevalues)
    },
    beginweek(value){
      this.componentKey += 1;
      this.days = value === "su" ?  ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] :  ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat","Sun"];
    },
    lang(value){
      console.log(value)
      this.today = moment().locale(value).format("dddd");
      this.currentMonthInText = moment().locale(value).format("MMMM YYYY"),
      this.todayDate = moment().locale(value).format("D"),
      this.componentKey += 1;
    },
    cType(){
      this.defaultWidth = this.calcWidth;
      // this.adjustFontSizeTodayDate()
      // this.adjustFontSizeTExtTodayDate()
      // this.adjustFontSizeOfDates()
    }
  },
  computed: {
    adjustFontSizeTodayDate(){
      let boxWidthinPercent = (this.calcWidth / this.defaultWidth) * 100;
      let fontsize = (230  * this.zoomRatio / 100) * boxWidthinPercent;
      console.log(fontsize)
      return fontsize;
    },
    adjustFontSizeTExtTodayDate(){
      let boxWidthinPercent = (this.calcWidth / this.defaultWidth) * 100;
      let fontsize = (50  * this.zoomRatio / 100) * boxWidthinPercent;
      console.log(fontsize);
      return fontsize;
    },
    adjustFontSizeOfDates(){
      let boxWidthinPercent = (this.calcWidth / this.defaultWidth) * 100;
      let fontsize = (30 * this.zoomRatio / 100) * boxWidthinPercent;
      console.log(fontsize)
      return fontsize;
    },
    formatDate(format) {
      return moment().format(format);
    },
    calendar() {
      const firstDay = new Date(this.currentYear, this.currentMonth, 1).getDay();
      const lastDate = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
      const weeks = [];
      let week = [];

      let convertedDates = this.getDaysArrayByMonth().map(x => moment(x).locale(this.lang).format("D")).reverse();

      for (let i = 0; i < firstDay; i++) {
        week.push('');
      }
      for (let date = 1; date <= lastDate; date++) {
        // week.push(date);
        week.push(convertedDates[date - 1]);
        if (week.length === 7) {
          weeks.push(week);
          week = [];
        }
      }
      if (week.length > 0) {
        while (week.length < 7) {
          week.push('');
        }
        weeks.push(week);
      }
      console.log(weeks)
      return this.flattenNestedArray(weeks);
    },
  },
  methods: {
    flattenNestedArray(nestedArray) {
      const flatArray = [];
      for (const row of nestedArray) {
        for (const element of row) {
          flatArray.push(element);
        }
      }
      return flatArray;
    },
    getDaysArrayByMonth() {
      var daysInMonth = moment().daysInMonth();
      var arrDays = [];

      while (daysInMonth) {
        var current = moment().locale(this.lang).date(daysInMonth);
        arrDays.push(current);
        daysInMonth--;
      }
      this.changeHeadingLocale();
      return arrDays;
    },
    changeHeadingLocale(){
      let arr = this.days;
      const daysFormatted = arr.map((day, index) => {
      const formattedDay = moment().locale(this.lang).weekday(index + Number((this.beginweek === 'su'  ? 0 : 1))).format('dd');
      return formattedDay;
    });
      console.log(daysFormatted)
      this.days = daysFormatted;
    },
   

  },
}
</script>

<style scoped>
.noselect {
  -webkit-user-select: none;
  /* Chrome/Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+ */
}

#full-clndr {
  position: absolute;
  width: 100%;
  height: 100%;
  /* background-color: #010712; */
  font-weight: 700;
  /* -moz-box-shadow: 0px 4px 0 #343434; */
  /* -webkit-box-shadow: 0px 4px 0 #343434; */
  /* box-shadow: 0px 4px 0 #343434; */
  overflow: hidden;
}

#full-clndr .clndr {
  height: 100%;
  display: flex;
  flex-direction: column;
}

#full-clndr .clndr-controls {
  height: 0;
  background-color: #414141;
  color: white;
  text-align: center;
  display: none;
}

#full-clndr .clndr-controls .clndr-previous-button {
  text-align: left;
}

#full-clndr .clndr-controls .clndr-next-button {
  text-align: right;
}

#full-clndr .clndr-controls .clndr-previous-button,
#full-clndr .clndr-controls .clndr-next-button {
  width: 30px;
  cursor: pointer;
  -webkit-user-select: none;
  /* Chrome/Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+ */
}

#full-clndr .clndr-controls .clndr-previous-button:hover,
#full-clndr .clndr-controls .clndr-next-button:hover {
  opacity: 0.5;
}

#full-clndr .clndr-wrapper {
  flex: 1;
  display: flex;
}

#full-clndr .clndr-grid {
  width: 65%;
  height: 100%;
  /*border-right: 2px solid white;*/
  display: flex;
  flex-direction: column;
}

#full-clndr .clndr-grid .days-of-the-week {
  width: 100%;
  background-color: #28dcda;
}

#full-clndr .clndr-grid .days-of-the-week .header-day {
  width: 14.2857%;
  padding: 14px;
  text-align: center;
  color: #7048e8;
  font-weight: 400;
}

#full-clndr .clndr-grid .days {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-content: stretch;
}

#full-clndr .clndr-grid .days .day,
#full-clndr .clndr-grid .days .empty {
  width: 14.2857%;
  /*padding: 24px 0;*/
  text-align: center;
  color: #ecece7;
  background-color: #28dcda;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
}

#full-clndr .clndr-grid .days .day.event .day-number,
#full-clndr .clndr-grid .days .empty.event .day-number {
  padding-bottom: 4px;
  border-bottom: 2px solid #3883a3;
}

#full-clndr .clndr-grid .days .day.adjacent-month .day-number,
#full-clndr .clndr-grid .days .empty.adjacent-month .day-number {
  visibility: hidden;
}

#full-clndr .clndr-grid .days .today {
  color: #7048e8;
  /*background-image: none;*/
}

#full-clndr .today-block-v1 {
  display: none;
}

#full-clndr .today-block-v2 {
  width: 35%;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #7048e8;
  border-radius: 0 6px 6px 0;
  text-align: right;
  padding: 10px 30px;
  justify-content: center;
}

#full-clndr .today-block-v2 .today-block-wrapper {
  color: #28dcda;
}

#full-clndr .today-block-v2 .today-block-wrapper .dow {
  text-transform: uppercase;
  font-weight: 400;
  /* font-size: 8vmin; */
}

#full-clndr .today-block-v2 .today-block-wrapper .ym {
  text-transform: uppercase;
  font-weight: 400;
  /* font-size: 5vmin; */
}

#full-clndr .today-block-v2 .today-block-day {
  text-align: right;
  vertical-align: middle;
  /*line-height: 396px;*/
  /* font-size: 35vmin; */
  flex: 1;
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: center;*/
  color: #ecece7;
  font-weight: 500;
}

#full-clndr .today-block-v2 .today-block-day span {
  display: table-cell;
  vertical-align: middle;
}


.cwrapper p {
  line-height: 1.5em;
  margin-bottom: 1em;
}

.cwrapper p+h3 {
  margin-top: 3em;
}

.cwrapper a {
  text-decoration: none;
  background-color: #ebebeb;
  color: #3883a3;
  padding: 0 2px;
  border-radius: 2px;
  -webkit-transition: background-color 0.2s, color 0.4s;
  -moz-transition: background-color 0.2s, color 0.4s;
  -ms-transition: background-color 0.2s, color 0.4s;
  -o-transition: background-color 0.2s, color 0.4s;
  transition: background-color 0.2s, color 0.4s;
}

.cwrapper a:hover {
  background-color: #98cede;
  color: #212121;
}

.cwrapper span.code {
  padding: 0 2px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 2px;
}

.block {
  padding: 80px 0;
  width: 100%;
}

.inner {
  max-width: 960px;
  padding: 0 20px;
  margin: 0 auto;
}

.clearfix:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
}

.clearfix {
  display: inline-block;
}


.bg-gray {
  background-color: #414141;
}

.bg-red {
  background-color: #ff5a45;
}

.bg-red a {
  color: #ff5a45;
}

.bg-red a:hover {
  background-color: #ffb4ab;
  color: #212121;
}

.bg-blue {
  background-color: #71bbd2;
}

.bg-green {
  background-color: #97ce7f;
}

.bg-yellow {
  background-color: #ddca9a;
}

.center {
  text-align: center;
}

.header {
  padding: 30px 0;
}

.more-space {
  margin-top: 3em;
}
</style>